@if (signupState.value !== SignupState.TOKEN_INVALID) {
  <div class="row gx-0 pt-md-5 sign-up-container" data-test-id="sign-up-container">
    <div class="col-md-6 p-5 sign-up-message full-height">
      <img
        class="sign-up-logo"
        src="/static/assets/images/LevelAccess_Logo_White-RGB.svg"
        alt="{{ 'level_access' | translate }}"
      />
      @if (signupState.value === SignupState.SIGNUP) {
        <div class="mb-5">
          <h2 class="sign-up-message-header">{{ 'sign_up_welcome_header' | translate }}</h2>
          <p>{{ 'sign_up_welcome_message' | translate }}</p>
        </div>
        <div>
          <h2 class="sign-up-message-header">{{ 'sign_up_notes' | translate }}</h2>
          <ul>
            <li>{{ 'sign_up_notes_display_name' | translate }}</li>
            <li>{{ 'sign_up_notes_activation_link' | translate }}</li>
          </ul>
        </div>
      }
      @if (signupState.value === SignupState.PLATFORM_USAGE) {
        <div class="sign-up-platform-usage">
          <img
            class="sign-up-platform-usage-illustration"
            src="/static/assets/images/Product-Platform-Usage-Illustration.svg"
            [alt]="'platform_usage_alt_text' | translate"
          />
        </div>
      }
      @if (signupState.value === SignupState.OVERVIEW) {
        <div class="sign-up-platform-structure">
          <div class="sign-up-platform-structure-header">{{ 'sign_up_platform_structure_header' | translate }}</div>
          <img
            class="sign-up-platform-structure-image"
            src="/static/assets/images/platform-structure.svg"
            [alt]="'sign_up_platform_structure_alt_text' | translate"
          />
        </div>
      }
    </div>
    <div class="col-md-6 full-height">
      <div class="sign-up-card p-4 p-lg-5 me-md-5">
        <div class="mb-4">
          <h1>
            {{ title }}
            @if (showStep$ | async) {
              <span class="font-weight-400">
                {{ 'sign_up_step_x_of_total' | translate: [currentSignupStep, totalSignupSteps] }}
              </span>
            }
          </h1>
        </div>
        @switch (signupState.value) {
          @case (SignupState.SIGNUP) {
            <app-signup-form
              [confirmEmailToken]="confirmEmailToken"
              [email]="email"
              (onSuccess)="onSignupSuccess($event)"
            ></app-signup-form>
          }
          @case (SignupState.PLATFORM_USAGE) {
            <app-signup-platform-usage [email]="email" (onSuccess)="onPlatformUsageSubmitSuccess()"></app-signup-platform-usage>
          }
          @case (SignupState.OVERVIEW) {
            <app-signup-overview [tenantName]="tenantName" (onSuccess)="onOverviewSuccess()"></app-signup-overview>
          }
        }
      </div>
    </div>
  </div>
} @else {
  <div class="row sign-up-container-invalid-link" data-test-id="sign-up-container-invalid-link">
    <div class="col-12 p-5">
      <div class="mb-4">
        <h1>{{ 'sign_up_invalid_link_header' | translate }}</h1>
      </div>
      <div>
        <p>{{ 'sign_up_invalid_link_message' | translate }}</p>
      </div>
    </div>
  </div>
}
